<template>
    <loader :visible="visible" :type="type" :elements="elements"></loader>
</template>
<script>
  import DataGridLoader from 'js/theme-mixins/DataGridLoader';

  export default {
    mixins: [DataGridLoader],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridLoader.vue